import { Component, OnInit } from '@angular/core';

// ionic
import { ModalController } from '@ionic/angular';

// rxjs
import { interval, Subject, Subscription } from "rxjs";
import { debounceTime, take, takeUntil } from "rxjs/operators";

// components
import { LiveVotingComponent } from "../../components/live-voting/live-voting.component";

// providers
import { EventService } from "../../services/event.service";
import { UserService } from "../../services/user.service";
import { OverlayService } from "../../services/overlay.service";
import { PlatformService } from "../../services/platform.service";
import { VotingService } from "../../services/voting.service";

// models
import { Event } from "../../models/event";
import { Feed } from "../../models/feed";
import { User } from "../../models/user";
import { ChatGroup } from "../../models/chat-group";
import { Voting } from "../../models/voting";

// extends
import { BasePage } from "../base";

@Component({
    selector: 'app-live-votings',
    templateUrl: './live-votings.page.html',
    styleUrls: ['./live-votings.page.scss'],
})
export class LiveVotingsPage extends BasePage implements OnInit {

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * subscription for questions auto refresh
     *
     * @type {Subscription}
     */
    private subscriptionRefresh: Subscription;

    /**
     * current event
     *
     * @type {User}
     */
    public user: User;

    /**
     * selected language
     *
     * @type string
     */
    public userLang: string;

    /**
     * event
     *
     * @type {Event}
     */
    public event: Event;

    public liveVotings: Voting[];

    private votingOpened: boolean = false;

    constructor(
        public votingService: VotingService
    ) {
        super();
    }

    ngOnInit() {
        this.userService.getCurrentUser().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe(
            (user: User) => {
                this.user = user;
            });
    }

    ionViewWillEnter() {
        this.userService.getCurrentUser()
            .pipe(
                take(1),
                debounceTime(0)
            ).subscribe(
                (user) => {
                    if (user.id) {
                        this.user = user;
                        this.event = this.user.selected_participant.event;

                        if (!this.event.id) {
                            // TODO redirect to no event if event is not available
                            this.router.navigate([this.plt.defaultLink + '/no-event']);
                        } else {

                            this.loadLiveVotings();

                            // cancel previous subscription
                            if (this.subscriptionRefresh) {
                                this.subscriptionRefresh.unsubscribe();
                            }

                            //load questions periodically
                            this.subscriptionRefresh = interval(30000).pipe(
                                takeUntil(this.ngUnsubscribe)
                            ).subscribe(() => {
                                this.loadLiveVotings();
                            });

                            this.plt.activeSubscriptions.push(this.subscriptionRefresh);
                        }
                    }
                });
    }

    ionViewWillLeave() {
        // cancel previous subscription
        if (this.subscriptionRefresh) {
            this.subscriptionRefresh.unsubscribe();
        }
    }

    loadLiveVotings() {
        // process chat group notifications
        if (this.user) {
            // return list of available valid voting IDs
            this.votingService.getLiveVotings(this.user.selected_participant_id).subscribe(
                (votings: Voting[]) => {
                    this.liveVotings = votings;
                }, (error) => {
                    console.error(error);
                });
        }
    }
}
